// src/config/contentTypes.js
//
// Sprint 2c-2a foundation: content-type registry + classification helper.
// Migrated verbatim from prototype/between-the-lines-v2.html lines 5688-5719
// (CONTENT_TYPE_LABELS 5690-5704, CONTENT_TYPE_ORDER 5705,
//  OBJECTIVE_CONTENT_TYPES 5711-5718, isObjectiveContentType 5719).
//
// Used by Sprint 2c-2b: SubmissionContentView, SubmissionDetailView,
// MyTutorReviewPanel.

// Content-type registry: stable keys mapped to display labels.
// The admin "enabled content types" picker uses this list.
export const CONTENT_TYPE_LABELS = {
    'set-text-quiz':            'Set Text Quiz',
    'set-text-mixed-quiz':      'Mixed Review Quiz',
    'set-text-long-question':   'Set Text Long Question',
    'swp-unit-quiz':       'Skills Workshop Unit Quiz',
    'swp-past-paper':      'Skills Workshop Past Paper',
    'swp-guided-advanced': 'Skills Workshop Guided Practice (Advanced)',
    'lit-character-quiz':  'Literature Character Quiz',
    'lit-theme-quiz':      'Literature Theme Quiz',
    'lit-symbol-quiz':     'Literature Symbol Quiz',
    'lit-sample-essay':    'Literature Sample Essay',
    'lit-timed-essay':     'Literature Timed Essay',
    'lit-practice':        'Literature Practice'
};

export const CONTENT_TYPE_ORDER = Object.keys(CONTENT_TYPE_LABELS);

// Objective content types are auto-graded (MCQ / Fill / Match / T-F).
// They never consume the tutor-review quota and never show the
// AI / Tutor / Both choice dialog. Subjective types (essays, papers,
// mocks, open-ended practice) require the choice dialog.
export const OBJECTIVE_CONTENT_TYPES = new Set([
    'set-text-quiz',
    'set-text-mixed-quiz',
    'swp-unit-quiz',
    'lit-character-quiz',
    'lit-theme-quiz',
    'lit-symbol-quiz'
]);

export const isObjectiveContentType = (ct) => OBJECTIVE_CONTENT_TYPES.has(ct);
